import Model from "../Model";

export default class Message extends Model {
    get url() {
        return '/api/messages';
    }
}